import _ from 'lodash';

export function objectPropHasChanged(original, next) {
  return (_.isEmpty(original) && !_.isEmpty(next)) || !_.matches(original)(next);
}

export function safeJsonParse(obj) {
  try {
    return JSON.parse(obj);
  } catch (e) {
    return {};
  }
}
